import moment from 'moment';

const columnOverrides = [
  {
    field: 'dtemissao',
    valueGetter: ({ value }) => value && moment(value).format('DD/MM/YYYY'),
  },
  {
    field: 'preco',
    valueGetter: ({ value }) =>
      value &&
      value?.toLocaleString('pt-br', {
        style: 'currency',
        currency: 'BRL',
      }),
  },
];

export default columnOverrides;
